var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcTopProveedores(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9.49731,
    r: 6.75,
    stroke: "#01295F",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69669 15.3047V21.5284L12 19.3543L15.3033 21.5284V15.3046",
    stroke: "#01295F",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9193 5.80806C11.9523 5.74117 12.0477 5.74117 12.0807 5.80806L13.1114 7.89641C13.1245 7.92297 13.1498 7.94138 13.1791 7.94564L15.4838 8.28052C15.5576 8.29125 15.5871 8.38197 15.5336 8.43403L13.866 10.0596C13.8448 10.0803 13.8351 10.1101 13.8401 10.1392L14.2338 12.4346C14.2464 12.5081 14.1692 12.5641 14.1032 12.5294L12.0419 11.4457C12.0157 11.432 11.9843 11.432 11.9581 11.4457L9.89681 12.5294C9.83078 12.5641 9.75361 12.5081 9.76622 12.4346L10.1599 10.1392C10.1649 10.1101 10.1552 10.0803 10.134 10.0596L8.46637 8.43403C8.41295 8.38197 8.44243 8.29125 8.51625 8.28052L10.8209 7.94564C10.8502 7.94138 10.8755 7.92297 10.8886 7.89641L11.9193 5.80806Z",
    fill: "#01295F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTopProveedores);
export default __webpack_public_path__ + "static/media/ic_top_proveedores.44fc0c662019e4b2acff6d1fb09afd07.svg";
export { ForwardRef as ReactComponent };